import { ApiResult, request, safeRequest } from '@synergy/api';

import { ProductDetail } from '../models/product-detail';
import { ProductDetailRequest } from './models/product-overview-request';

export class ProductDetailOverviewApi {
    constructor(protected baseUrl: string) {}

    public getDetail(id: number): Promise<ApiResult<ProductDetail>> {
        return safeRequest(
            () => request.get(`${this.baseUrl}/products/${id}/details`),
            response => {
                return response.data;
            }
        );
    }

    public patchDetail(productId: number, productRequest: ProductDetailRequest): Promise<ApiResult<ProductDetail>> {
        return safeRequest(
            () => request.patch(`${this.baseUrl}/products/${productId}/details`, productRequest),
            response => response.data
        );
    }

    public createDetail(productRequest: ProductDetailRequest): Promise<ApiResult<ProductDetail>> {
        return safeRequest(
            () =>
                request.post(`${this.baseUrl}/products`, productRequest, {
                    params: { isSync: true },
                }),
            response => response.data
        );
    }
}
